import type Room from "../../../src/models/Room";
import roomTemplates, { defaultFloorFinishForRoomType } from "../data/C1_roomTemplates";
import { roomTypeFromName } from "../data/C1_roomTypeFromName";
import type { RoomDraft } from "../types/C1_AppTypes";

/** Shared by toolbar and navigator placement; type inference does not mutate the room. */
export function existingRoomDraft(room: Room): RoomDraft {
  const type = room.c1?.type ?? roomTypeFromName(room.name);
  const template = roomTemplates.find(candidate => candidate.type === type);
  return {
    existingRoomId: room.id, name: room.name, type,
    width: template?.defaultWidth ?? 3, height: template?.defaultHeight ?? 2.5,
    floorFinish: room.c1?.floorFinish ?? defaultFloorFinishForRoomType(type),
  };
}
